"use strict";
/// <reference path="irep.js"/>

IREP.passwordReset = (function() {
    var upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var lower = upper.toLowerCase();
    var number = "1234567890";
    var special = "|[!\"#$%&'()*+,-./:;=>?@[\]^_`{|}~]";

    var verifyPasswordsMatch = function () {
        $("#statusMessages > div").hide();
        var passwordsMatch = $("#newPassword").val() === $("#confirmPassword").val();
        var password = $("#newPassword").val();
        var valid = false;
        if (!passwordsMatch) {
            $("#passwordsDontMatch").show();
            valid = false;
        }
        else if (password.length < 6 || !(myContains(password, upper) || myContains(password, lower)) || !myContains(password, number) || !myContains(password, special)) {
            $("#complexityNotMet").show();
            valid = false;
        } else {
            valid = true;
        }
        if (!valid) {
            $("#statusMessages").show();
            return false;
        } else {
            return true;
        }
    };

    var myContains = function(password, validChars) {
        for (var i = 0; i < password.length; i++) {
            var char = password.charAt(i);
            if (validChars.indexOf(char) > -1) {
                return true;
            }
        }
        return false;
    };

    return {
        verifyPasswordsMatch: verifyPasswordsMatch
    };
})();